// Play mode: single-player (your own island) or a shared world (Phase 4). Each has its own save.
import { TUNABLES } from "@degen/shared/config/tunables";

export type Mode = "solo" | "shared";
const KEY = "degen-world:mode";

export function playMode(): Mode {
  try {
    return localStorage.getItem(KEY) === "shared" ? "shared" : "solo";
  } catch {
    return "solo";
  }
}

export function switchMode(m: Mode) {
  try {
    localStorage.setItem(KEY, m);
  } catch {
    /* ignore */
  }
  location.href = location.pathname;
}

export function saveKey(mode: Mode = playMode()): string {
  return mode === "shared" ? `${TUNABLES.save.storageKey}:shared` : TUNABLES.save.storageKey;
}
